import React, {useState} from "react";
import axios from "axios";
import "../styles/QuestionGroupForm.css";

export default function QuestionGroupForm() {
    const [groupName, setGroupName] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        axios.post(`${process.env.REACT_APP_API_URL}/question-groups`, {groupName})
            .then(() => alert("Soru grubu başarıyla eklendi!"))
            .catch((err) => alert("Hata: " + err.message));
    };

    return (
        <form onSubmit={handleSubmit} className="question-group-form">
            <h2>Yeni Soru Grubu Ekle</h2>
            <label htmlFor="groupName">Grup Adı</label>
            <input
                type="text"
                id="groupName"
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                placeholder="Grup Adı"
                required
            />
            <button type="submit">Kaydet</button>
        </form>
    );
}

